import React, { useEffect, useState } from "react";
import * as S from "../../style/StyleComponentSection";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import { get_point_transaction_list } from "../../Axios";
import { commaPrice, get_day_timestamp } from "../../Validation";
import Pagination from "../Utility/Pagination";
import arrowIcon from "../../assets/icons/arrow_forward_ios.svg";

interface PointHistoryList {
    customer_ID : number;
    history_date : Date;
    history_memo : string;
    point_value : number;
    point_type : number;
};

const PointDetail: React.FC = () => {
    const customerData = useSelector((state:RootState) => state.customerData);
    const [page, setPage] = useState<number>(1);
    const [pointHistoryList, setPointHistoryList] = useState<PointHistoryList[]>([]);
    const [totalPointHistory, setTotalPointHistory] = useState<number>(0);
    const [field, setField] = useState<number>(0); // 정렬하는 필드 0 : PK
    const [listOrder, setListOrder] = useState<number>(0); // 상하행 정렬 0 : DESC, 1 : ASC
    
    useEffect(() => {
        if(!customerData.customer_ID) return;
        get_point_transaction_list(customerData.customer_ID, page, field, listOrder).then(result => {
            setPointHistoryList(result.rows);
            setTotalPointHistory(result.total_count);
        });
    },[customerData.customer_ID, field, listOrder, page]);

    const handlePage = (page: number) => {
        setPage(page);
    };

    const handleSort = (field_num: number) => {
        if(field !== field_num) {
            setField(field_num);
            setListOrder(1);
        } else {
            if(listOrder === 1) {
                setListOrder(0);
            } else if (listOrder === 0) {
                setField(0)
            }
        };
        setPage(1) // 정렬시 1페이지로 이동 => 삭제해도 무방
    };
    
    return (
        <S.SectionContainer>
            <S.SectionWidth $width={1080}>
                <S.SectionTitleBox>
                    <h1>AP포인트 내역</h1>
                    <h3>AP포인트 사용 내역을 확인할 수 있습니다.</h3>

                    <div className="flex justify-center items-center w-[100%] h-[120px] rounded-[5px] mt-[50px] border-solid border-[0.5px] border-middleGray02 text-mainBlack">
                        <span className="px-6 text-[18px] font-light">보유 AP포인트</span>
                        <span className="px-6 text-[21px] font-semibold">{commaPrice(Number(customerData.customer_point))} AP</span>
                    </div>
                </S.SectionTitleBox>

                <p className="font-semibold my-3">AP포인트 내역</p>

                <S.ReservationTableHead>
                    <div className="sortable-box w-20" onClick={() => handleSort(1)}>
                        <span>
                            진행상태
                            <img src={arrowIcon} className={`${field === 1 ? `block ${listOrder === 0 ? "rotate-90" : "rotate-[270deg]"}` : "hidden"}`} alt="" />
                        </span>
                    </div>
                    <div className="sortable-box w-32" onClick={() => handleSort(2)}>
                        <span>
                            내역
                            <img src={arrowIcon} className={`${field === 2 ? `block ${listOrder === 0 ? "rotate-90" : "rotate-[270deg]"}` : "hidden"}`} alt="" />
                        </span>
                    </div>
                    <div className="sortable-box w-[60%]" onClick={() => handleSort(3)}>
                        <span>
                            상세내역
                            <img src={arrowIcon} className={`${field === 3 ? `block ${listOrder === 0 ? "rotate-90" : "rotate-[270deg]"}` : "hidden"}`} alt="" />
                        </span>
                    </div>
                    <div className="sortable-box w-32" onClick={() => handleSort(4)}>
                        <span>
                            사용일자
                            <img src={arrowIcon} className={`${field === 4 ? `block ${listOrder === 0 ? "rotate-90" : "rotate-[270deg]"}` : "hidden"}`} alt="" />
                        </span>
                    </div>
                </S.ReservationTableHead>

                <div>
                    {pointHistoryList.map((tmp, idx) => 
                        <S.ReservationTableBody $withBtn={false} key={idx}>
                            <div 
                                className="pay-status-box w-20"
                                style={{
                                    backgroundColor : `${tmp.point_type === 2 ? `#FFF` : `#111827`}`,
                                    color : `${tmp.point_type === 2 ? `#111827` : `#FFF`}`,
                                    border : `${tmp.point_type === 2 ? `solid 0.5px #111827` : ``}`
                                }}
                            >
                                {tmp.point_type === 2 ? "사용" : "적립"}
                            </div>
                            <div className="w-32 font-semibold">{tmp.point_type === 2 ? `-${commaPrice(tmp.point_value)} AP` : `+${commaPrice(tmp.point_value)} AP`}</div>
                            <div className="request-box w-[60%]">{tmp.history_memo}</div>
                            <div className="w-32">{get_day_timestamp(tmp.history_date).year_month_day}</div>
                        </S.ReservationTableBody>
                    )}
                </div>

                <Pagination totalCount={totalPointHistory} handlePage={handlePage} listCount={8} page={page} />
                <br />
                <br />
                <br />

            </S.SectionWidth>
        </S.SectionContainer>
    )
};

export default PointDetail;